// sync.js — save everything: the local mirror always, the cloud when signed in.

import { S, buildState } from './state.js';
import { saveToLocal } from './local.js';
import { getUID, saveUserData, getCloudTotals } from '../db.js';

export async function saveAll() {
  saveToLocal();
  if (getUID()) {
    try {
      await saveUserData(buildState());
      const t = getCloudTotals(); if (t) S.cloudTotals = t;
    } catch (e) {
      alert("⚠️ Couldn't save your tasks to the cloud. They'll stay on this device.");
      console.error(e);
    }
  }
}
